var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component.tag,_vm._g(_vm._b(_vm._b({tag:"component",class:[
    _vm.css(),
    _vm.css('', _vm.type),
    _vm.css('', _vm.size),
    ( _obj = {}, _obj[_vm.css('', _vm.AtomAnchorTypeEnum.DISABLED)] = _vm.isDisabled, _obj[_vm.css('', 'loading')] = _vm.isLoading, _obj ) ],attrs:{"data-test":"anchor","disabled":_vm.isDisabled}},"component",_vm._d({},[_vm.component.attr,_vm.link])),'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.isLoading)?_c('div',{class:_vm.css('circle')}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }